/**
 * 查询模块专用 API
 * 区域接口需要在 header 中指定 region，而非使用全局 sessionStorage 中的区域
 */
import { fetch } from './fetch'

const api = '/admin/v1/'

// 包装函数：区域接口自动在 headers 中带上 region
function regionFetch(options, region) {
    if (region) {
        options.headers = Object.assign({}, options.headers, { region: region })
    }
    return fetch(options)
}

export default {
    // ===== 用户相关（全球接口，不需要 region header） =====
    // 用户列表
    QueryUserList(params) {
        return fetch({ url: `${api}migrage_user/list`, method: 'get', params })
    },
    // APP列表
    QueryAppList(params) {
        return fetch({ url: `${api}client_app/list`, method: 'get', params })
    },

    // ===== 用户相关（区域接口，需要 region header） =====
    // 用户详情
    QueryUserDetail(params) {
        return regionFetch(
            { url: `${api}migrage_user/detail`, method: 'get', params },
            params.region
        )
    },
    // 用户账号
    QueryUserAccount(params) {
        return regionFetch(
            { url: `${api}migrage_user/account`, method: 'get', params },
            params.region
        )
    },
    // 用户登录APP列表
    QueryUserLoginList(params) {
        return regionFetch(
            { url: `${api}migrage_user/login_list`, method: 'get', params },
            params.region
        )
    },
    // 用户信任设备列表
    QueryUserTrustDevList(params) {
        return regionFetch(
            {
                url: `${api}migrage_user/trusted_devices_list`,
                method: 'get',
                params
            },
            params.region
        )
    },
    // 用户设备列表
    QueryUserDeviceList(params) {
        return regionFetch(
            { url: `${api}migrage_device/list`, method: 'get', params },
            params.region
        )
    },
    // 用户设备影子
    QueryUserDeviceShadow(params) {
        return regionFetch(
            { url: `${api}shadow/user/device`, method: 'get', params },
            params.region
        )
    },
    // 用户设备云存储
    QueryUserDeviceCloudInfo(params) {
        return regionFetch(
            {
                url: `${api}online_device/get_cloud_info`,
                method: 'get',
                params
            },
            params.region
        )
    },

    // ===== 设备相关（区域接口） =====
    // 设备详情
    QueryDeviceDetail(params) {
        return regionFetch(
            { url: `${api}online_device/detail`, method: 'get', params },
            params.region
        )
    },
    // 设备日志
    QueryDeviceLogs(params) {
        return regionFetch(
            { url: `${api}online_device/device_logs`, method: 'get', params },
            params.region
        )
    },
    // 设备日志类型（使用 identifier/list 接口，区域接口）
    QueryDeviceLogsType(params) {
        return regionFetch(
            {
                url: `${api}online_device/identifier/list`,
                method: 'get',
                params
            },
            params.region
        )
    },
    // 设备属性值类型列表（使用 identifier/value/list 接口，区域接口）
    QueryDeviceLogsValueType(params) {
        return regionFetch(
            {
                url: `${api}online_device/identifier/value/list`,
                method: 'get',
                params
            },
            params.region
        )
    },
    // 设备属性值记录
    QueryIdentifierValues(params) {
        return regionFetch(
            {
                url: `${api}online_device/identifier/values`,
                method: 'get',
                params
            },
            params.region
        )
    },
    // 设备消息
    QueryDeviceMessageList(params) {
        return regionFetch(
            { url: `${api}message/device_message_list`, method: 'get', params },
            params.region
        )
    },
    // 设备消息按日汇总（查询参数仅需 uuid，region 走 header）
    QueryDeviceMessageDailySummary(params) {
        return regionFetch(
            {
                url: `${api}message/device_message_daily_summary`,
                method: 'get',
                params: { uuid: params.uuid }
            },
            params.region
        )
    },
    // 云回放信息
    QueryCloudFileList(params) {
        return regionFetch(
            { url: `${api}cloud/video/files`, method: 'get', params },
            params.region
        )
    },
    // 查询4G设备网络情况
    QueryDeviceNetInfo(params) {
        return regionFetch(
            { url: `${api}online_device/net/info`, method: 'get', params },
            params.region
        )
    },
    // 更新4G设备网络配置
    QueryDeviceNetUpdate(params) {
        const { region, ...body } = params
        return regionFetch(
            { url: `${api}online_device/net/update`, method: 'post', data: body },
            region
        )
    },
    // 物模型属性列表（用于设备影子属性映射）
    QueryTslAttributeList(params) {
        return fetch({ url: `${api}tsl/attribute/list`, method: 'get', params })
    },
    // 服务等级列表
    QueryPackageLevelList(params) {
        return fetch({
            url: `${api}set_meal/level/list`,
            method: 'get',
            params
        })
    }
}
